@if (model?.name && optionGroup?.options) {
    <div class="name">{{ model.name }}</div>
}
<div [ngClass]="viewType === viewTypeEnum.SixPack ? 'column-view' : 'row-view'">
    @for (option of optionGroup?.options; track option.id; let index = $index) {
        <ms-event-pick
            [option]="option"
            [event]="event"
            [optionGroup]="optionGroup"
            [trackingSource]="optionTracking"
            [trackingPosition]="tracking?.position"
            [ngClass]="!optionGroup.online || !option.online ? 'grid-option-selectable offline' : 'grid-option-selectable'">
            @if (!optionGroup.online || !option.online) {
                <vn-icon name="theme-locked-i" [size]="13"></vn-icon>
            } @else {
                @if ((optionGroup.balanced && (optionGroup.categoryAttribute || option.optionAttribute)) || viewType === viewTypeEnum.Default) {
                    <div class="option-attribute">
                        {{ getResultName(option, index) }}
                    </div>
                }
                <div
                    [ngClass]="
                        (viewType === viewTypeEnum.SixPack &&
                            (!optionGroup.balanced || !(optionGroup.categoryAttribute || option.optionAttribute))) ||
                        !(option.overridenName || option.name)
                            ? 'option-position result-odds option-value'
                            : 'result-odds option-value'
                    ">
                    <ms-font-resizer defaultSize="1" maxChars="8" [value]="option.nativePrice | msNativePriceFormatter"></ms-font-resizer>
                </div>
            }
        </ms-event-pick>
    }
</div>
